<template>
    <section>
        <nav class="navbar-default navbar-static-side" role="navigation">
            <div class="sidebar-collapse">
                <ul class="nav metismenu" id="side-menu">
                    <li class="nav-header">
                        <div class="dropdown profile-element">
                            <div class="logo_class">
                                <i class="fa fa-user"></i>
                            </div>
                            <a data-toggle="dropdown" class="dropdown-toggle" href="#">
                            <span class="clear"> <span class="block m-t-xs">
                              <strong class="font-bold">{{user.fullName}} {{(user.userRolesById[0].role === 'ROLE_BRANCH') ? '('+ user.branch.areasByAreaId.name +')' : ""}}</strong>
                             </span> <span class="text-muted text-xs block">{{user.userRolesById[0].role.split('_')[1]}} <b class="caret"></b></span> </span> </a>
                            <ul class="dropdown-menu animated fadeInRight m-t-xs">
                                <li><a  data-toggle="modal" data-target="#updatePasswordModal">Change Password</a></li>
                                <li class="divider"></li>
                                <li><a href="javascript:void(0)" v-on:click="logout()">Logout</a></li>
                            </ul>
                        </div>
                        <div class="logo-element">
                            <img src="img/logo-small.png" alt="DM" style="width:53%;">
                        </div>
                    </li>
                    <!-- <li title="Dashboard" v-bind:class="'m_tip ' + hiddenForAgent + ' ' + hiddenForBranch + ' ' + hiddenForUser" >
                        <router-link to="/coming_soon"><i class="fa fa-th-large"></i> <span class="nav-label">Dashboard</span></router-link>
                    </li> -->
                    <li title="Dashboard" v-bind:class="'m_tip ' + hiddenForAgent + ' ' + hiddenForBranch" >
                        <router-link to="/dashboard"><i class="fa fa-line-chart"></i> <span class="nav-label">Dashboard</span></router-link>
                    </li>
                    <li title="QR Analytics" v-bind:class="'m_tip ' + hiddenForAgent + ' ' + hiddenForBranch + ' ' + hiddenForManager" >
                        <router-link to="/qr_analytics"><i class="fa fa-qrcode"></i> <span class="nav-label">QR Analytics</span></router-link>
                    </li>
                    <li title="Call History" v-bind:class="'m_tip ' + hiddenForAgent + ' ' + hiddenForUser + ' ' + hiddenForBranch + ' ' + hiddenForManager">
                        <router-link to="/callHistory"><i class="fa fa-history"></i> <span class="nav-label">Call History</span></router-link>
                    </li>
                    <li title="Admin Billings" v-bind:class="'m_tip ' + hiddenForAgent + ' ' + hiddenForBranch  + ' ' + hiddenForUser + ' ' + hiddenForManager" >
                        <router-link to="/admin_billings"><i class="fa fa-money"></i> <span class="nav-label">Admin Billings</span></router-link>
                    </li>
                    <li title="Branch Orders" v-bind:class="'m_tip ' + hiddenForAgent + ' ' + hiddenForUser + ' ' + hiddenForAdmin + ' ' + hiddenForPortalDisable">
                        <router-link to="/branch_orders"><i class="fa fa-gears (alias)"></i> <span class="nav-label">Branch Orders</span></router-link>
                    </li>
                    <li title="Billings And Subscriptions" v-bind:class="'m_tip ' + hiddenForAgent + ' ' + hiddenForBranch + ' ' + hiddenForManager" >
                        <router-link to="/restaurant_billings"><i class="fa fa-usd"></i> <span class="nav-label">Billings/Subscriptions</span></router-link>
                    </li>
                    <li title="Orders" v-bind:class="'m_tip '">
                        <router-link to="/orders"><i class="fa fa-shopping-cart"></i> <span class="nav-label">Orders</span></router-link>
                    </li>
                    <li title="View Menu" v-bind:class="'m_tip ' +  hiddenForBranch">
                        <router-link to="/view_menu"><i class="fa fa-list"></i> <span class="nav-label">View Menu</span></router-link>
                    </li>
                    <li title="Branch Menu" v-bind:class="'m_tip ' + hiddenForAgent + ' ' + hiddenForAdmin + ' ' + hiddenForUser + ' ' + hiddenForManager">
                        <router-link to="/menu"><i class="fa fa-list"></i> <span class="nav-label">Branch Menu</span></router-link>
                    </li>
                    <li title="New Order" v-on:click="toggleNavBar()" v-bind:class="'m_tip ' +  hiddenForBranch">
                        <router-link to="/new_delivery_order"><i class="fa fa-cart-plus"></i> <span class="nav-label">Punch New Order</span></router-link>
                    </li>
                    <li title="New Reservation" v-on:click="toggleNavBar()" v-bind:class="'m_tip ' +  hiddenForBranch + ' ' + hiddenForUser + ' ' + hiddenForManager">
                        <router-link to="/reservations"><i class="fa fa-ticket"></i> <span class="nav-label">Add New Reservation</span></router-link>
                    </li>
                  <li title="POS Dashboard" v-bind:class="'m_tip '+ hiddenForAdmin + ' ' + hiddenForUser + ' ' + hiddenForAgent">
                    <router-link to="/pos_dashboard"><i class="fa fa-area-chart"></i><span class="nav-label">POS Dashboard</span></router-link>
                  </li>
                    <li title="Point Of Sale" v-bind:class="'m_tip ' + hiddenForAgent  + ' ' + hiddenForUser  + ' ' + hiddenForManager">
                        <router-link to="/point_of_sale"><i class="fa fa-shopping-cart"></i><span class="nav-label"> Point Of Sale</span></router-link>
                    </li>
                    <li title="Complaints" v-bind:class="'m_tip ' +  hiddenForBranch">
                        <router-link to="/complaints"><i class="fa fa-headphones"></i> <span class="nav-label">Complaints</span></router-link>
                    </li>
                    <li title="Restaurants" v-bind:class="'m_tip ' +  hiddenForBranch">
                        <router-link to="/restaurants"><i class="fa fa-building"></i> <span class="nav-label">Restaurants</span></router-link>
                    </li>
                  <li title="Restaurants" v-bind:class="'m_tip ' +  hiddenForAgent + ' ' + hiddenForUser + ' '+ hiddenForAdmin  + ' ' + hiddenForManager">
                    <router-link to="/restaurant"><i class="fa fa-building"></i> <span class="nav-label">Restaurants</span></router-link>
                  </li>
                    <li title="Users" v-bind:class="'m_tip ' + hiddenForAgent + ' ' + hiddenForUser + ' ' + hiddenForBranch + ' ' + hiddenForManager" >
                        <router-link to="/users"><i class="fa fa-user"></i> <span class="nav-label">Users</span></router-link>
                    </li>
                    <li title="DVM Customers" v-bind:class="'m_tip ' +  hiddenForBranch">
                        <router-link to="/customers"><i class="fa fa-users"></i> <span class="nav-label">DVM Customers</span></router-link>
                    </li>
                    <li :title="$store.getters.getValidPlatform + ' Customers'" v-bind:class="'m_tip ' +  hiddenForBranch + ' ' + hiddenForUser">
                      <router-link to="/bayked_customers"><i class="fa fa-laptop"></i><span class="nav-label">{{$store.getters.getValidPlatform}} Customers</span></router-link>
                    </li>
                    <li title="Riders" v-bind:class="'m_tip'">
                        <router-link to="/riders"><i class="fa fa-motorcycle"></i><span class="nav-label">Riders</span></router-link>
                    </li>
                    <li title="Feedback" v-bind:class="'m_tip ' + hiddenForAgent + ' ' + hiddenForBranch">
                        <router-link to="/feedback"><i class="fa fa-comment"></i><span class="nav-label">Feedback</span></router-link>
                    </li>
                    <li :title="$store.getters.getValidPlatform + ' Orders Review'" v-bind:class="'m_tip ' + hiddenForBranch + ' ' + hiddenForManager">
                      <router-link to="/bayked_orders_feedback"><i class="fa fa-star"></i><span class="nav-label">{{$store.getters.getValidPlatform}} Orders Feedback</span></router-link>
                    </li>
                    <li title="Coupons" v-bind:class="'m_tip ' + hiddenForBranch + ' ' + hiddenForUser">
                        <router-link to="/coupons"><i class="fa fa-tag fa-lg"></i><span class="nav-label">Coupons</span></router-link>
                    </li>
                    <li :title="$store.getters.getValidPlatform + ' Exclusive Deals'" v-bind:class="'m_tip ' + hiddenForBranch + ' ' + hiddenForUser + ' ' + hiddenForAgent">
                      <router-link to="/bayked_exclusive_deals"><i class="fa fa-stack-exchange fa-lg"></i><span class="nav-label">{{$store.getters.getValidPlatform}} Exclusive Deals</span></router-link>
                    </li>
                    <li title="Areas" v-bind:class="'m_tip '+ hiddenForBranch + ' ' + hiddenForUser">
                        <router-link to="/areas"><i class="fa fa-map-marker fa-lg"></i><span class="nav-label">Areas</span></router-link>
                    </li>
                    <li title="Live Status of Branches" v-bind:class="'m_tip '+ hiddenForBranch + ' ' + hiddenForUser + ' ' + hiddenForAgent">
                        <router-link to="/live_status_of_branches"><i class="fa fa-wifi"></i><span class="nav-label">Live Status of Branches</span></router-link>
                    </li>
<!--                    <li title="Real Time Stats" v-bind:class="'m_tip '+ hiddenForBranch + ' ' + hiddenForUser">-->
<!--                        <router-link to="/real_time_stats"><i class="fa fa-area-chart fa-lg"></i><span class="nav-label">Real Time Stats</span></router-link>-->
<!--                    </li>-->
                </ul>
            </div>
        </nav>
        <!-- Modal -->
        <div class="modal fade" id="updatePasswordModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title" id="updatePasswordModalLabel">Update Password</h4>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Old Password</label>
                            <input type="password" v-model="oldPassword" placeholder="Old Password..." class="form-control"/>
                        </div>
                        <div class="form-group">
                            <label>New Password</label>
                            <input type="password" v-model="newPassword" placeholder="New Password..." class="form-control"/>
                        </div>
                        <div class="form-group">
                            <label>Re-Type New Password</label>
                            <input type="password" v-model="reCheckNewPassword" placeholder="Re-Type New Password..." class="form-control"/>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="button" v-on:click="changeUserPassword()" class="btn btn-primary">Change Password</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
/* eslint-disable */
//update_user_password
import user from "@/services/User"

export default {
    name: "Navigation",
    data() {
        return {
            oldPassword: "",
            newPassword: "",
            reCheckNewPassword: "",
            user: {},
            hiddenForAgent: "",
            hiddenForUser: "",
            hiddenForBranch: "",
            hiddenForAdmin: "",
            hiddenForManager: "",
            hiddenForPortalDisable:'hide',
            hiddenForPortalEnable: "",
            userRole: ""
        }
    },
    created: function () {
        this.user = this.$store.state.user;
        this.userRole = this.$store.state.user.userRolesById[0].role.split('_')[1];
        // let isRoleAgent = user.verifyUserRole("ROLE_AGENT");
        // user.verifyUserRole("ROLE_AGENT").then(res => {
        //     this.hiddenForAgent = "hide";
        // });
        // user.verifyUserRole("ROLE_USER").then(res => {
        //     this.hiddenForUser = "hide";
        // });
        if (this.userRole === 'AGENT') {
            this.hiddenForAgent = "hide";
        }
        if (this.userRole === 'USER' || this.userRole === 'FRANCHISE') {
            this.hiddenForUser = "hide";
        }
        if (this.userRole === 'BRANCH') {
            this.hiddenForBranch = "hide";
        }
        if (this.userRole === 'ADMIN') {
            this.hiddenForAdmin = "hide";
        }
        if (this.userRole === 'MANAGER') {
            this.hiddenForManager = "hide";
        }
        if(this.user.branch && this.user.branch.isPortalEnabled && this.userRole === 'BRANCH'){
            this.hiddenForPortalDisable="";
            this.hiddenForPortalEnable= 'hide';
        }
    },
    mounted: function () {
        $(".m_tip").tooltip({placement: "right"});
        $('#side-menu').metisMenu();
        $("body").addClass("mini-navbar");
    },
    methods: {
        toggleNavBar: function () {
            if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {

                $("body").toggleClass("mini-navbar");
                // Remove all inline style from jquery fadeIn function to reset menu state
                $('#side-menu').removeAttr('style');
                $(".m_tip").tooltip({placement: "right"});
            }

        },

        logout: function () {

            this.$store.dispatch('logout').then(() => {
                console.log(this.$state);
                this.$router.push('/');
            });
        },

        changeUserPassword: function () {
            if (this.oldPassword === "" || this.newPassword === "") {
                swal("Error!", "All fields are required!", "error");
                return;
            }
            if (this.newPassword !== this.reCheckNewPassword) {
                swal("Error!", "Please re-confirm the password", "error");
                return;
            }
            let params = new URLSearchParams();
            params.append("user_id", this.user.id);
            params.append("new_password", this.newPassword);
            params.append("old_password", this.oldPassword);
            this.$http.post(this.$store.state.mainAppURL + "users/update_user_password", params).then(resp => {
                if (resp.data) {
                    this.newPassword = "";
                    this.oldPassword = "";
                    this.reCheckNewPassword = "";
                    swal("SUCCESS!", "Password has been successfully updated", "success");
                    $("#updatePasswordModal").modal("hide");
                } else {
                    swal("ERROR!", "Incorrect old password", "error");
                }
            });
        }
    }
}
</script>

<style scoped>
.logo_class {
    max-width: 48px;
    height: 48px;
    border: solid 1px;
    border-radius: 50px;
    padding-left: 11px;
    font-size: 30px;
}

.logo_class > i {
    color: #FFFFFF;
}
</style>
